export const ITEM_IDS = {
  indoors: {
    pillows: '01000001-0000-4000-8000-000000000001',
    blankets: '01000002-0000-4000-8000-000000000002',
    sleepingBag: '01000003-0000-4000-8000-000000000003',
    airMattress: '01000004-0000-4000-8000-000000000004',
    powerBank: '01000005-0000-4000-8000-000000000005',
  },
  outdoors: {
    tent: '02000001-0000-4000-8000-000000000001',
    flashlights: '02000002-0000-4000-8000-000000000002',
    cooler: '02000003-0000-4000-8000-000000000003',
    firestarter: '02000004-0000-4000-8000-000000000004',
    kindling: '02000005-0000-4000-8000-000000000005',
    citronella: '02000006-0000-4000-8000-000000000006',
  },
  furniture: {
    pavilion: '03000001-0000-4000-8000-000000000001',
    hammock: '03000002-0000-4000-8000-000000000002',
    chairs: '03000003-0000-4000-8000-000000000003',
    table: '03000004-0000-4000-8000-000000000004',
  },
  clothes: {
    tshirts: '04000001-0000-4000-8000-000000000001',
    layering: '04000002-0000-4000-8000-000000000002',
    raincoat: '04000003-0000-4000-8000-000000000003',
    sweater: '04000004-0000-4000-8000-000000000004',
    socks: '04000005-0000-4000-8000-000000000005',
    pantsShorts: '04000006-0000-4000-8000-000000000006',
    underwear: '04000007-0000-4000-8000-000000000007',
    swimsuit: '04000008-0000-4000-8000-000000000008',
    sunhat: '04000009-0000-4000-8000-000000000009',
    sunglasses: '0400000a-0000-4000-8000-00000000000a',
    hikingBoots: '0400000b-0000-4000-8000-00000000000b',
    sandals: '0400000c-0000-4000-8000-00000000000c',
  },
  food: {
    spices: '05000001-0000-4000-8000-000000000001',
    eggs: '05000002-0000-4000-8000-000000000002',
    cookingOil: '05000003-0000-4000-8000-000000000003',
    drinks: '05000004-0000-4000-8000-000000000004',
    smores: '05000005-0000-4000-8000-000000000005',
    produce: '05000006-0000-4000-8000-000000000006',
    meats: '05000007-0000-4000-8000-000000000007',
    condiments: '05000008-0000-4000-8000-000000000008',
    bread: '05000009-0000-4000-8000-000000000009',
    deli: '0500000a-0000-4000-8000-00000000000a',
    snacks: '0500000b-0000-4000-8000-00000000000b',
    saltySnacks: '0500000c-0000-4000-8000-00000000000c',
    beer: '0500000d-0000-4000-8000-00000000000d',
    foodBowlsWithLids: '0500000e-0000-4000-8000-00000000000e',
    servingBowls: '0500000f-0000-4000-8000-00000000000f',
  },
  hygiene: {
    handSoap: '06000001-0000-4000-8000-000000000001',
    towels: '06000002-0000-4000-8000-000000000002',
    bodySoap: '06000003-0000-4000-8000-000000000003',
    hairbrush: '06000004-0000-4000-8000-000000000004',
    toothbrush: '06000005-0000-4000-8000-000000000005',
    cottonSwabs: '06000006-0000-4000-8000-000000000006',
    toiletPaper: '06000007-0000-4000-8000-000000000007',
    menstrual: '06000008-0000-4000-8000-000000000008',
    deodorant: '06000009-0000-4000-8000-000000000009',
    babyWipes: '0600000a-0000-4000-8000-00000000000a',
  },
  recreational: {
    fishing: '07000001-0000-4000-8000-000000000001',
    boardGames: '07000002-0000-4000-8000-000000000002',
    books: '07000003-0000-4000-8000-000000000003',
    speaker: '07000004-0000-4000-8000-000000000004',
    binoculars: '07000005-0000-4000-8000-000000000005',
    sports: '07000006-0000-4000-8000-000000000006',
  },
  cleanUp: {
    paperTowels: '08000001-0000-4000-8000-000000000001',
    trashBags: '08000002-0000-4000-8000-000000000002',
    sponge: '08000003-0000-4000-8000-000000000003',
    dirtyClothesBags: '08000004-0000-4000-8000-000000000004',
    stainRemover: '08000005-0000-4000-8000-000000000005',
    portableSink: '08000006-0000-4000-8000-000000000006',
  },
  safety: {
    handSanitizer: '09000001-0000-4000-8000-000000000001',
    spareCash: '09000002-0000-4000-8000-000000000002',
    sunscreen: '09000003-0000-4000-8000-000000000003',
    insectRepellant: '09000004-0000-4000-8000-000000000004',
    spareBatteries: '09000005-0000-4000-8000-000000000005',
  },
  firstAid: {
    bandages: '0a000001-0000-4000-8000-000000000001',
    alcohol: '0a000002-0000-4000-8000-000000000002',
    antiItch: '0a000003-0000-4000-8000-000000000003',
    tweezers: '0a000004-0000-4000-8000-000000000004',
    antihistamines: '0a000005-0000-4000-8000-000000000005',
  },
  personal: {
    phone: '0b000001-0000-4000-8000-000000000001',
    wallet: '0b000002-0000-4000-8000-000000000002',
    keys: '0b000003-0000-4000-8000-000000000003',
    lipBalm: '0b000004-0000-4000-8000-000000000004',
  },
} as const;

export type ItemId =
  (typeof ITEM_IDS)[keyof typeof ITEM_IDS][keyof (typeof ITEM_IDS)[keyof typeof ITEM_IDS]];

export const ALL_ITEM_IDS: readonly string[] = Object.values(ITEM_IDS).flatMap((category) =>
  Object.values(category)
);
